import { createSlice, current } from '@reduxjs/toolkit'

//Определит id_tab
function tabGet(model) {
    var id_tab = null;

    //Черновик
    if (model.ID_Status === 0) {
        id_tab = 0;
    }
    if (model.ID_Status === 1) {
        id_tab = 1;
    }
    return id_tab;
}
const labelList = createSlice({
    name: 'labelList',
    initialState: {
        list: [],
        listObject: [],
        listProject: [],
        listLoaded: []
    },
    reducers: {
        //id_tab: 1-Активные; 0-Архивные;
        //id_tab = id_status
        load(state, action) {
            const id_tab = action.payload.id_tab;
            const list = action.payload.list;
            state.list = [...state.list.filter(a => a.id_tab !== id_tab), ...list.map((item) => { return { ...item, id_tab: id_tab, filter_project: false, filter_object: false } })].sort((a, b) => a.ID - b.ID);
            state.listLoaded = [...state.listLoaded.filter(a => a.id_tab !== id_tab), { id_tab: id_tab }];
        },
        loadObject(state, action) {
            const id_tab = action.payload.id_tab;
            const list = action.payload.list;
            state.listObject = [...state.listObject.filter(a => a.id_tab !== id_tab), ...list.map((item) => { return { ...item, id_tab: id_tab } })];
        },
        loadProject(state, action) {
            const id_tab = action.payload.id_tab;
            const list = action.payload.list;
            state.listProject = [...state.listProject.filter(a => a.id_tab !== id_tab), ...list.map((item) => { return { ...item, id_tab: id_tab } })];
        },
        update(state, action) {
            const id_label = action.payload.id_label;
            const model = action.payload.model;

            //const listObject = action.payload.listObject;
            //const listProject = action.payload.listProject;

            state.list = [...state.list.filter(a => a.ID !== id_label), { ...model, id_tab: model.ID_Status, filter_project: false, filter_object: false }].sort((a, b) => a.ID - b.ID);
            //state.listObject = [...state.listObject.filter(a => a.ID_Label !== id_label), ...listObject.map((item) => { return { ...item, id_tab: model.ID_Status } })];
            //state.listProject = [...state.listProject.filter(a => a.ID_Label !== id_label), ...listProject.map((item) => { return { ...item, id_tab: model.ID_Status } })];
        },

        updateObject(state, action) {
            const id_label = action.payload.id_label;
            const data = action.payload.data;

            const ID_Tab = state.list.filter(a => a.ID !== id_label)[0].ID_Status;

            /*console.log('id_label', id_label)
            console.log('data', data)
            console.log('ID_Tab', ID_Tab)*/

            state.listObject = [...state.listObject.filter(a => a.ID_Label !== id_label), ...data.map((item) => { return { ...item, id_tab: ID_Tab } })];
        },
        updateProject(state, action) {
            const id_label = action.payload.id_label;
            const data = action.payload.data;

            const ID_Tab = state.list.filter(a => a.ID !== id_label)[0].ID_Status;

            /*console.log('id_label', id_label)
            console.log('data', data)
            console.log('ID_Tab', ID_Tab)*/

            state.listProject = [...state.listProject.filter(a => a.ID_Label !== id_label), ...data.map((item) => { return { ...item, id_tab: ID_Tab } })];
        },

        remove(state, action) {
            const id_label = action.payload.id_label;
            state.list = [...state.list.filter(a => a.ID !== id_label)].sort((a, b) => a.ID - b.ID);
            state.listObject = [...state.listObject.filter(a => a.ID_Label !== id_label)];
            state.listProject = [...state.listProject.filter(a => a.ID_Label !== id_label)];
        },
        filterProject(state, action) {
            const id_tab = action.payload.id_tab;
            const id_project = action.payload.id_project;

            //Очишаем предыдущие значения
            state.list = state.list.map((item) => {
                if (item.id_tab === id_tab) {
                    return { ...item, filter_project: false }
                }
                else {
                    return { ...item }
                }
            })

            //Устанавливаем/снимаем фильтр
            if (id_project > 0) {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab & state.listProject.filter(a => a.ID_Label === item.ID & a.ID_Project === id_project).length === 0) {
                        return { ...item, filter_project: true }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
            if (id_project === 0) {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab & item.All_Project !== true) {
                        return { ...item, filter_project: true }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
        },
        filterObject(state, action) {
            const id_tab = action.payload.id_tab;
            const id_object = action.payload.id_object;

            //Очишаем предыдущие значения
            state.list = state.list.map((item) => {
                if (item.id_tab === id_tab) {
                    return { ...item, filter_object: false }
                }
                else {
                    return { ...item }
                }
            })

            //Устанавливаем/снимаем фильтр
            if (id_object > 0) {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab & state.listObject.filter(a => a.ID_Label === item.ID & a.ID_Object === id_object).length === 0) {
                        return { ...item, filter_object: true }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
            if (id_object === 0) {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab & item.All_Object !== true) {
                        return { ...item, filter_object: true }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
        },
    }
})

export const { load, loadObject, loadProject, remove, update, filterProject, filterObject, updateObject, updateProject } = labelList.actions
export default labelList.reducer